import { render, staticRenderFns } from "./ProjectPhasesActions.vue?vue&type=template&id=357cb3c2&"
import script from "./ProjectPhasesActions.vue?vue&type=script&lang=js&"
export * from "./ProjectPhasesActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports